import script from "./CategoryCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryCard.vue?vue&type=script&setup=true&lang=js"

import "./CategoryCard.vue?vue&type=style&index=0&id=7df64b9a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7df64b9a"]])

export default __exports__